module.exports = __webpack_public_path__ + "static/media/graviCubeMain.d3bb36d3.png";